export default {"src":"/_next/static/media/BHC.f64bf377.svg","height":18,"width":18};